// Textarea — presentation primitive. Native <textarea>. Selector-free,
// dispatch-free. The surrounding Field primitive wires id /
// aria-describedby / aria-invalid via React.cloneElement; consumers
// using Textarea outside a Field can pass them directly.
//
// Textarea is permanently plain-text only. See CLAUDE.md and
// migration/phase13-primitive-stabilization-plan.md §2.2.
//
// Forbidden forever:
//   autosize, markdown preview, mentions, slash commands, formatting
//   toolbars, uploads, emoji systems, rich text, contenteditable,
//   editor plugins, WYSIWYG.
//
// Props:
//   id:           string — textarea id (Field injects this)
//   name:         string — passed through
//   value:        string — controlled value
//   onChange:     (event) => void
//   onBlur:       (event) => void
//   placeholder:  string
//   rows:         number — default 4
//   maxLength:    number
//   disabled:     bool
//   className, ...rest

function Textarea({
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  rows = 4,
  maxLength,
  disabled = false,
  className = '',
  ...rest
}) {
  const classes = [
    'ui-textarea',
    disabled ? 'ui-textarea--disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <textarea
      id={id}
      name={name}
      value={value ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      rows={rows}
      maxLength={maxLength}
      disabled={disabled}
      className={classes}
      {...rest}
    />
  );
}

export default Textarea;
